import React, { useState } from 'react';

const SOURCES = [
  { id: 'gsc',    label: 'GSC',            emoji: '🔍', desc: 'Google Search Console'       },
  { id: 'ga4',    label: 'GA4',            emoji: '📊', desc: 'Google Analytics 4'          },
  { id: 'gsheet', label: 'Google Sheets',  emoji: '📋', desc: 'Live Google Sheets Data'     },
  { id: 'karma2', label: 'Karma 2',        emoji: '📈', desc: 'Rankings & Domain Authority'  },
  { id: 'karma1', label: 'Karma 1',        emoji: '🔗', desc: 'Backlinks & Submissions'     },
  { id: 'gbp',    label: 'GMB',            emoji: '📍', desc: 'Google Business Profile (reviews, ratings, performance, posts)' },
  { id: 'project_team', label: 'Project Team', emoji: '🧑‍💼', desc: 'Manager & Executives (Project Registry)' },
  { id: 'kb',     label: 'Knowledge Base', emoji: '📚', desc: 'Internal Docs & Sheets'      },
  { id: 'web',    label: 'Web',            emoji: '🌐', desc: 'Live Web Search'              },
];

export default function SourcePicker({ question, onConfirm, onCancel }) {
  // Default: nothing selected — user must pick
  const [selected, setSelected] = useState(new Set());

  const toggle = (id) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const selectAll = () => setSelected(new Set(SOURCES.map(s => s.id)));
  const clearAll  = () => setSelected(new Set());

  const handleAsk = () => {
    if (selected.size === 0) return;
    onConfirm(Array.from(selected));
  };

  return (
    <div className="source-picker">
      <div className="source-picker-header">
        <span className="source-picker-icon">✦</span>
        <span className="source-picker-title">Which sources should I use?</span>
      </div>
      <p className="source-picker-question">"{question}"</p>

      <div className="source-chips">
        {SOURCES.map(src => (
          <button
            key={src.id}
            className={`source-chip ${selected.has(src.id) ? 'selected' : ''}`}
            onClick={() => toggle(src.id)}
            title={src.desc}
          >
            <span className="source-chip-emoji">{src.emoji}</span>
            <span className="source-chip-label">{src.label}</span>
          </button>
        ))}
      </div>

      <div className="source-picker-actions">
        <div className="source-picker-toggles">
          <button className="source-select-all" onClick={selectAll}>Select All</button>
          <span className="source-picker-sep">·</span>
          <button className="source-select-all" onClick={clearAll}>Clear</button>
        </div>
        <div className="source-picker-right">
          <button className="source-cancel-btn" onClick={onCancel}>Cancel</button>
          <button
            className="source-ask-btn"
            onClick={handleAsk}
            disabled={selected.size === 0}
          >
            {selected.size === 0
              ? 'Select a source'
              : `Ask Guru (${selected.size} source${selected.size !== 1 ? 's' : ''})`}
          </button>
        </div>
      </div>
    </div>
  );
}
